<template>
    <div class="d-flex flex-column">
        <div class="d-flex align-center justify-space-between mb-12 mb-lg-24">
            <h5 class="tit-txt">이용시간</h5>
            <div class="d-flex align-center">
                <div class="d-flex align-center mr-12 mr-lg-26">
                    <span class="point grey-dark"></span>
                    <p class="page-text--sm">마감</p>
                </div>
                <div class="d-flex align-center mr-12 mr-lg-26">
                    <span class="point primary-light"></span>
                    <p class="page-text--sm">승인대기</p>
                </div>
                <div class="d-flex align-center">
                    <span class="point--checkbox"></span>
                    <p class="page-text--sm">승인대기</p>
                </div>
            </div>
        </div>

        <p v-if="isOnHoliday" class="page-text color-grey">운영하지 않는 날짜입니다</p>
        <p v-else-if="!isOnBusiness" class="page-text color-grey">운영하지 않는 요일입니다</p>
        <v-row v-else class="row--x-small">
            <v-col cols="6" sm="4" md="2" lg="6" xl="4" v-if="subject.isWholeDayRent">
                <rental-schedule-whole-day v-bind="{ loading, schedules, schedulesOnCloud, subject, date, limitationMet }" v-on="{ add, del }" />
            </v-col>
            <v-col cols="6" sm="4" md="2" lg="6" xl="4" v-else v-for="time in subject.businessHours" :key="time">
                <time-cell-disabled v-if="isClosed(time)" v-bind="{ subject, schedulesOnCloud, date, time }" />
                <time-cell-checkbox v-else :key="`${subject.name}-${time}`" v-bind="{ schedules, subject, time, date, limitationMet }" v-on="{ add, del }" />
            </v-col>
        </v-row>

        <v-sheet>
            <h5 class="tit-txt my-12 my-lg-24">안내사항</h5>
            <v-card flat color="grey-light" rounded>
                <v-card-text class="pa-12 pa-lg-24">
                    <ul class="pl-20" style="list-style-type: disc">
                        <li>예약승인 대기중에는 신청이 제한되며, 관리자 승인 후 예약 신청이 완료됩니다.</li>
                    </ul>
                </v-card-text>
            </v-card>
        </v-sheet>
    </div>
    <!-- <v-sheet outlined rounded class="fill-height">
        <v-card-title>이용시간</v-card-title>
        <v-divider />
        <v-card-text v-if="isOnHoliday"> 운영하지 않는 날짜입니다 </v-card-text>
        <v-card-text v-else-if="!isOnBusiness"> 운영하지 않는 요일입니다 </v-card-text>
        <span v-else-if="subject.isWholeDayRent">
            <v-col> <rental-schedule-whole-day v-bind="{ loading, schedules, schedulesOnCloud, subject, date, limitationMet }" v-on="{ add, del }" /> </v-col>
        </span>
        <v-card-text v-else>
            <v-row>
                <v-col v-for="time in subject.businessHours" :key="time" cols="3" md="2" lg="1">
                    {{ time }}시
                    <time-cell-disabled v-if="isClosed(time)" v-bind="{ subject, schedulesOnCloud, date, time }" />
                    <time-cell-checkbox v-else :key="`${subject.name}-${time}`" v-bind="{ schedules, subject, time, date, limitationMet }" v-on="{ add, del }" />
                </v-col>
            </v-row>
        </v-card-text>
    </v-sheet> -->
</template>

<script>
import dayjs from "dayjs";

import TimeCellCheckbox from "./time-cell-checkbox.vue";
import TimeCellDisabled from "./time-cell-disabled.vue";
import RentalScheduleWholeDay from "./rental-schedule-whole-day.vue";

export default {
    components: {
        TimeCellCheckbox,
        TimeCellDisabled,
        RentalScheduleWholeDay,
    },
    props: {
        loading: { type: Boolean, default: false },

        date: { type: String, default: Date.now().toDate() },
        value: { type: Array, default: () => [] },
        subject: { type: Object, default: () => ({}) },
        limitationMet: { type: Boolean, default: false },
        schedulesOnCloud: { type: Array, default: () => [] },
    },
    data: () => ({
        schedules: [],
    }),
    computed: {
        isOnHoliday() {
            return (this.subject?.holidays || []).some((date) => dayjs(this.date).isSame(date, "date"));
        },
        isOnBusiness() {
            return (this.subject?.businessDays || []).includes(dayjs(this.date).day());
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        schedules() {
            this.$emit("input", this.schedules);
        },
    },
    methods: {
        sync() {
            this.schedules = this.value;
        },
        isClosed(time) {
            let hasTimePassed = dayjs().isAfter(dayjs(this.date).set("hour", time));
            if (hasTimePassed) return true;

            let hasSchedule = this.schedulesOnCloud.some(({ datetime }) => dayjs(datetime).isSame(dayjs(this.date).set("hour", time), "hour"));

            if (hasSchedule) return true;
        },
        add(schedule) {
            this.schedules = this.schedules.concat([schedule]);
        },
        del(schedule) {
            let { _subject, date, time } = schedule;
            let index = this.schedules.findIndex((item) => item._subject == _subject && item.date == date && item.time == time);
            if (index > -1) this.schedules.splice(index, 1);
        },
        toggleSchedule() {
            if (this.isChecked) this.$emit("del", this.schedule);
            else if (this.limitationMet) alert("한 주 동안 3시간을 초과해 대여할 수 없습니다");
            else this.$emit("add", this.schedule);
        },
    },
};
</script>

<style scoped>
.point {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 4px;
}
.point--checkbox {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 2px solid rgba(0, 0, 0, 0.87);
    margin-right: 4px;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .point {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .point--checkbox {
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
}
@media (min-width: 1200px) {
}
</style>
